module.exports = __webpack_public_path__ + "assets/img/side-navigation-base-c7b64693.png";